// removed by extract-text-webpack-plugin
module.exports = {"search":"create-user__search-3TAYL","inlineInput":"create-user__inlineInput-25x9z","searchBtn":"create-user__searchBtn-1a2d4 blocks__button-1iODk blocks__green-2w7kK","createBtn":"create-user__createBtn-I5LRt blocks__button-1iODk blocks__blue-tjpdI","message":"create-user__message-2XO_h"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/orders-options/create-user/create-user.css
// module id = 763
// module chunks = 0